import { Component, EventEmitter, inject, input, Input, OnInit, Output, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-custom-paginator',
  templateUrl: './custom-paginator.component.html',
  styleUrls: ['./custom-paginator.component.scss'],
  standalone: true,
  imports: [MaterialModule, TranslateModule, FormsModule],
})
export class CustomPaginatorComponent implements OnInit {
  @Input() pageSizeOptions;
  @Input() totalLength;
  @Input() type;
  @Input() currentPage = 0;
  @Input() borderTop = false;
  @Input() smallContainer = false;
  @Input() showSizeSelector = true;

  initialSize = input(5);
  selectedSize: WritableSignal<number> = signal(this.initialSize());

  @Output() page = new EventEmitter<any>();

  private authService = inject(AuthService);

  ngOnInit(): void {
    if (this.pageSizeOptions.length) {
      this.selectedSize.set(this.pageSizeOptions[0]);
    }
    this.authService.getUserConfigurationDocument().then((config: any) => {
      if (Number.isFinite(config.paginator[this.type])) {
        this.selectedSize.set(config.paginator[this.type]);
        this.page.emit({ page: this.currentPage, pageSize: this.selectedSize() });
      }
    });
  }

  getFirstElementOfPageIndex() {
    return this.currentPage * this.selectedSize() + 1;
  }

  getLastElementOfPageIndex() {
    const maxPage = (this.currentPage + 1) * this.selectedSize();
    return maxPage > this.totalLength ? this.totalLength : maxPage;
  }

  sendNewPageNotification(page?) {
    const nextPage = page || this.currentPage;
    if (nextPage >= 0 && nextPage <= this.getLastPage()) {
      this.page.emit({ page: nextPage, pageSize: this.selectedSize() });
    }
  }

  onItemPerPageChange(newSize: number) {
    this.selectedSize.set(newSize);

    this.authService.getUserConfigurationDocument().then((config: any) => {
      const paginator = config.paginator || {};
      paginator[this.type] = newSize;
      this.authService.setUserConfigurationDocument({ paginator });
    });
    if (newSize == 10) {
      if (this.currentPage % 2 != 0) {
        this.goToPreviousPage();
      } else {
        this.page.emit({ page: this.currentPage, pageSize: newSize });
      }
    } else {
      if (this.currentPage >= 0 && this.currentPage <= this.getLastPage()) {
        this.page.emit({ page: this.currentPage, pageSize: newSize });
      }
    }
  }

  goToFirstPage() {
    this.currentPage = 0;
    this.sendNewPageNotification();
  }

  goToPreviousPage() {
    this.currentPage = this.currentPage - 1;
    this.sendNewPageNotification();
  }

  goToNextPage() {
    this.currentPage = this.currentPage + 1;
    this.sendNewPageNotification();
  }

  goToLastPage() {
    this.currentPage = this.getLastPage();
    this.sendNewPageNotification();
  }

  getLastPage() {
    return Math.floor((this.totalLength - 1) / this.selectedSize());
  }
}
